import classNames from 'classnames/bind';
import styles from './KinhDich.module.scss';
import { Container, Grid, Hidden } from '@mui/material';
import images from '../../../assets/images';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import KinhDichDetail from './KinhDichDetail';
import { getLocalStorage, getMenhByYear, setLocalStorage } from '../../../utils/helper';
import solarlunar from 'solarlunar';
import { timSimPT } from '../../../services/listSim';
const cx = classNames.bind(styles);

export default function SearchSimKinhDich() {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const menhSimSo = urlParams.get('m');
  const mangSim = urlParams.get('mang') || '';
  const rangeSim = urlParams.get('range') || '';
  const bySim = urlParams.get('by') || '';
  const checkUrlSoDep = location.pathname === '/so-dep' ? true : false;
  const navigate = useNavigate();
  const [messageErro, setMessageErro] = useState('');
  const [isSearch, setIsSearch] = useState(checkUrlSoDep);

  const [arrPhone, setArrPhone] = useState({
    phone: '',
    day: '',
    month: '',
    year: '',
    hour: '',
    cccd: '',
    isLunar: true,
    gender: 'nam',
  });
  const textSim = urlParams.get('q');
  const ngayDuNien = urlParams.get('ngay');
  const thangDuNien = urlParams.get('thang');
  const namDuNien = urlParams.get('nam');
  const gioDuNien = urlParams.get('gio');
  const gioitinhDuNien = urlParams.get('gioitinh');
  const lichDuNien = urlParams.get('lich');
  const hostname = window.location.hostname;
  const menhSim = menhSimSo ? menhSimSo : namDuNien ? getMenhByYear(namDuNien) : '';
  const checkParam = () => {
    const dmySim = getLocalStorage('dmy');
    let arrSim = { ...arrPhone };
    if (ngayDuNien) {
      if (ngayDuNien) {
        arrSim = { ...arrSim, day: ngayDuNien };
      }
      if (thangDuNien) {
        arrSim = { ...arrSim, month: thangDuNien };
      }
      if (namDuNien) {
        arrSim = { ...arrSim, year: namDuNien };
      }
      if (gioDuNien) {
        arrSim = { ...arrSim, hour: gioDuNien };
      }
      if (gioitinhDuNien) {
        arrSim = { ...arrSim, gender: gioitinhDuNien };
      }
      if (lichDuNien) {
        arrSim = { ...arrSim, isLunar: lichDuNien === 'al' ? true : false };
      }
    } else if (dmySim) {
      arrSim = {
        ...arrSim,
        day: dmySim?.day,
        month: dmySim?.month,
        year: dmySim?.year,
        hour: dmySim?.hour,
        isLunar: dmySim?.lich,
        gender: dmySim?.gender,
        cccd: dmySim?.cccd,
      };
      setArrPhone({ ...arrSim, phone: textSim });
    }
    if (textSim) {
      setArrPhone({ ...arrSim, phone: textSim });
    }
  };

  const timSim = async (date = '', sim = '', cccd = '', status = 1) => {
    await timSimPT(date, sim, cccd, status, hostname);
  };

  const handleAnalyze = async () => {
    const day = arrPhone?.day ? `&ngay=${arrPhone?.day}` : '';
    const month = arrPhone?.month ? `&thang=${arrPhone?.month}` : '';
    const year = arrPhone?.year ? `&nam=${arrPhone?.year}` : '';
    const hour = arrPhone?.hour ? `&gio=${arrPhone?.hour}` : '';
    const isLunar = arrPhone?.isLunar ? `&lich=al` : `&lich=dl`;
    const gender = arrPhone?.gender ? `&gioitinh=${arrPhone?.gender}` : '';
    const cccd = arrPhone?.cccd ? `&cccd=${arrPhone?.cccd}` : '';

    if (arrPhone?.phone === '' || arrPhone?.phone === null) {
      alert('Bạn chưa nhập số điện thoại hoặc nhập sai');
    } else if (!arrPhone?.day && !arrPhone?.month && !arrPhone?.year) {
      alert('Bạn chưa nhập ngày/tháng/năm + Giờ sinh');
    } else {
      if (arrPhone?.day && arrPhone?.month && arrPhone?.year) {
        let d = Number(arrPhone?.day),
          m = Number(arrPhone?.month),
          y = Number(arrPhone?.year);
        if (!arrPhone?.isLunar) {
          const lunar = solarlunar.solar2lunar(y, m, d);
          d = lunar.lDay;
          m = lunar.lMonth;
          y = lunar.lYear; // chuẩn hóa dùng DL cho tính TK
        }

        setLocalStorage('dmy', {
          day: arrPhone?.day,
          month: arrPhone?.month,
          year: arrPhone?.year,
          hour: arrPhone?.hour,
          cccd: arrPhone?.cccd,
          lich: arrPhone?.isLunar,
          gender: arrPhone?.gender,
        });
      }
      await timSim(
        `${arrPhone?.day}/${arrPhone?.month}/${arrPhone?.year}-${arrPhone?.isLunar ? `al` : `dl`}-${arrPhone?.gender}`,
        arrPhone?.phone,
        cccd,
      );
      setIsSearch(true);
      navigate(`/so-dep?q=${arrPhone?.phone}${day}${month}${year}${hour}${isLunar}${gender}`, { replace: true });
      window.location.reload();
    }
  };

  const handleValue = (JSON) => {
    setIsSearch(false);
    setArrPhone({ ...arrPhone, ...JSON });
  };

  useEffect(() => {
    document.title = 'Sim Phong Thủy theo Kinh Dịch, Năng Lượng Số';
    checkParam();
  }, []);

  return (
    <Grid item xs={12} md={12}>
      <div>
        <div className={cx('bgr-search', 'pt-10')}>
          <h2 className={cx('title-search-2')}>chọn sim phong thủy</h2>
          <h2 className={cx('title-search')}> sim phong thủy đa dạng với năng lượng tích cực</h2>

          <div className={cx('form-row')}>
            <input
              type="text"
              placeholder="Nhập 09*, 03* hoặc 09*68 - Nhập đủ số để xem cát hung"
              className={cx('form-input')}
              value={arrPhone?.phone ?? ''}
              onChange={(e) => {
                handleValue({ phone: e.target.value });
              }}
            />
          </div>

          <div className={cx('form-row')}>
            <select
              className={cx('form-select')}
              value={arrPhone?.day}
              onChange={(e) => {
                handleValue({ day: e.target.value });
              }}
            >
              <option value="">Ngày sinh</option>
              {Array.from({ length: 31 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>

            <select
              className={cx('form-select')}
              value={arrPhone?.month}
              onChange={(e) => {
                handleValue({ month: e.target.value });
              }}
            >
              <option value="">Tháng sinh</option>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>

            <input
              type="number"
              placeholder="Năm sinh"
              className={cx('form-input')}
              value={arrPhone?.year ?? ''}
              onChange={(e) => {
                handleValue({ year: e.target.value });
              }}
            />
          </div>

          <div className={cx('form-row')}>
            <select
              className={cx('form-select')}
              value={arrPhone?.hour}
              onChange={(e) => {
                handleValue({ hour: e.target.value });
              }}
            >
              <option value="">Giờ sinh </option>
              {[
                'Tý (23h-01h)',
                'Sửu (01h-03h)',
                'Dần (03h-05h)',
                'Mão (05h-07h)',
                'Thìn (07h-09h)',
                'Tỵ (09h-11h)',
                'Ngọ (11h-13h)',
                'Mùi (13h-15h)',
                'Thân (15h-17h)',
                'Dậu (17h-19h)',
                'Tuất (19h-21h)',
                'Hợi (21h-23h)',
              ].map((g) => (
                <option key={g} value={g}>
                  {g}
                </option>
              ))}
            </select>
          </div>

          <div className={cx('form-row')}>
            <div className={cx('form-radio-inline')}>
              <span className={cx('radio-label')}>Loại lịch:</span>
              <label>
                <input
                  type="radio"
                  name="calendar"
                  value="dl"
                  checked={!arrPhone?.isLunar}
                  onChange={(e) => {
                    handleValue({ isLunar: e.target.value });
                  }}
                />
                Dương lịch
              </label>
              <label>
                <input
                  type="radio"
                  name="calendar"
                  value="al"
                  checked={arrPhone?.isLunar}
                  onChange={(e) => {
                    handleValue({ isLunar: true });
                  }}
                />
                Âm lịch
              </label>
            </div>

            <div className={cx('form-radio-inline')}>
              <span className={cx('radio-label')}>Giới tính:</span>
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="nam"
                  checked={arrPhone?.gender === 'nam'}
                  onChange={(e) => {
                    handleValue({ gender: e.target.value });
                  }}
                />
                Nam
              </label>
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="nu"
                  checked={arrPhone?.gender === 'nu'}
                  onChange={(e) => {
                    handleValue({ gender: e.target.value });
                  }}
                />
                Nữ
              </label>
            </div>
          </div>
          {messageErro && (
            <div>
              <b className={cx('red')}>{messageErro}</b>
            </div>
          )}
          <div className={cx('form-action', 'justify-center')}>
            <button className={cx('nut')} onClick={handleAnalyze}>
              CHỌN SIM HỢP TUỔI
            </button>
          </div>
        </div>
      </div>

      <Container sx={{ p: '0px' }} maxWidth="lg">
        {isSearch && (
          <KinhDichDetail
            menh={menhSim}
            sim={arrPhone?.phone}
            orderBy={bySim === '1' ? 'ASC' : bySim === '2' ? 'DESC' : ''}
            nhamang={mangSim}
            RangePrice={rangeSim}
          />
        )}
      </Container>
    </Grid>
  );
}
